import React, { useRef, useEffect } from 'react';
import './Others.css';
import othersImage from '../assets/images/2024publicspeakingphotos/6.png';

const Others = () => {
    const titleRef = useRef(null);
    
    useEffect(() => {
        titleRef.current.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
        });
    }, []);

    return (
        <div className="others-page" ref={titleRef}>
            <section className="others-hero">
                <h1>Past Initiatives</h1>
            </section>

            <div className="others-card">
                <div className="others-image-container">
                    <img src={othersImage} alt="CASC Initiatives" className="others-image" />
                </div>
                <div className="others-content">
                    <h2>Explore Our Work in the Archive</h2>
                    <div className="others-links">
                        <a 
                            href="https://byeigostudy.wixsite.com/casc/blog/categories/clean-air-voices" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="others-link"
                        >
                            Clean Air Voices — Our Monthly Blog &gt;
                        </a>
                        <a 
                            href="https://byeigostudy.wixsite.com/casc/blog/categories/others" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="others-link"
                        >
                            Past Conferences & Contests &gt;
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Others;